module.exports = __webpack_public_path__ + "img/P150T_weapon_48.1eaf23e0.png";